import StoresLogos from "components/shared/storesLogos/StoresLogos";
import { StoresStyled, Title } from "./Stores.styled";

export default function Stores() {
    return (
        <StoresStyled>
            <Title>Online en in de winkel in te wisselen bij: </Title>
            <StoresLogos redeem />
        </StoresStyled>
    );
}
